module.exports = __webpack_public_path__ + "static/media/icon_116.693f9e23.svg";